import Vue from "vue";

export default {
  SET_MASTER_MAP(state, payload) {
    Vue.set(state.masterMap, payload.masterName, payload.masterList);
  },
  SET_DESTINATION_WORK_TASK(state, { date, taskId, destinationWorkTask }) {
    if (!state.destinationWorkTasksMap[date]) {
      Vue.set(state.destinationWorkTasksMap, date, {});
    }
    Vue.set(state.destinationWorkTasksMap[date], taskId, destinationWorkTask);
  },
  DELETE_DESTINATION_WORK_TASK(state, payload) {
    if (state.destinationWorkTasksMap[payload.date]) {
      Vue.delete(state.destinationWorkTasksMap[payload.date], payload.taskId);
    }
  },
  ADD_FIRESTORE_SUBSCRIBE_LIST(state, data) {
    state.firestoreSubscribeList.push(data);
  },
  SET_TARGET_DATES(state, data) {
    state.displayDates = data;
  },
  UNSUBSCRIBE_FIRESTORE(state) {
    if (state.firestoreSubscribeList.length > 0) {
      state.firestoreSubscribeList.forEach((unsubscribe) => {
        unsubscribe();
      });
    }
  },
  SET_LAST_UPDATED_TIME_MAP(state, data) {
    Vue.set(state.lastUpdatedTimeMap, data.date, data.time);
  },
  SET_LAST_UPDATED_FOR_MASTERS(state, data) {
    state.lastUpdatedForMasters = data;
  },
  SET_LAST_UPDATED_FOR_TASKS(state, data) {
    state.lastUpdatedForTasks = data;
  },
  SET_SELECTED_CELL(state, data) {
    state.selectedTaskId = data.taskId;
    state.selectedColumnKey = data.columnKey;
  },
  SET_SUMMARY_DIALOG_SHOW_POPUP(state, data) {
    state.summaryDialogShowPopup = data;
  },
  /**
   * 表示する日付を更新する
   */
  SET_SELECTED_DATE(state, data) {
    if (!data) return;
    state.selectedDate = data;
  },
  // 画面操作で明示的に設定したフィルタの選択状態を更新
  SET_STORED_FILTER_RULE(state, data) {
    state.storedFilterRule = data;
  },
  SET_PRESENT_COLUMNS_FILTERING_STATE(state, data) {
    state.presentColumnsFilteringState = data;
  },
};
